const Select2Auto = {
    default: {
        length: 3,
        placeholder: '',
        language: 'en',
        clear: 1,
        url: null,
        param: null,
        delay: 2000,
    },
    init: function () {
        $('.select2-auto').each(function () {
            const settings = Select2Auto.createSettings(
                $(this).data('length') ?? Select2Auto.default.length,
                $(this).data('placeholder') ?? Select2Auto.default.placeholder,
                $(this).data('language') ?? Select2Auto.default.language,
                $(this).data('clear') ?? Select2Auto.default.clear,
                $(this).data('url') ?? Select2Auto.default.url,
                $(this).data('param') ?? Select2Auto.default.param,
                $(this).data('delay') ?? Select2Auto.default.delay,
            );
            Select2Auto.startObserve(this, settings);
            Select2Auto.applySelect2(this, settings);
        });
    },
    createSettings: function (length, placeholder, language, clear, url, param, delay) {
        ajax = null;

        if (url && param) {
            ajax = this.createAjax(url, param, delay);
        }

        return {
            ajax: ajax,
            minimumInputLength: length,
            language: language,
            placeholder: placeholder,
            allowClear: JSON.parse(clear),
        };
    },
    createAjax: function(url, param, delay) {
        return {
            url: url,
            type: 'GET',
            dataType: 'json',
            delay: delay,
            data: function (params) {
                return {
                    [param]: params.term,
                };
            },
            processResults: function (data, params) {
                return { results: data.items};
            },
            cache: true
        }
    },
    // this will reflect hidden attribute from select native input dom to select2 dom
    startObserve: function (select2, settings) {
        const observer = new MutationObserver((mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
                    if (select2.hidden) {
                        Select2Auto.destroySelect2(select2);
                    } else {
                        Select2Auto.applySelect2(select2, settings);
                    }
                }
            }
        });
        observer.observe(select2, { attributes: true });
    },
    applySelect2: function (select2, settings) {
        // Skip hidden selects
        if (select2.hidden) {
            return;
        }
        // skip if already initialized
        if (select2.classList.contains('select2-hidden-accessible')) {
            return;
        }
        $('#' + select2.id).select2(settings);
    },
    destroySelect2: function (select2) {
        // Check if is select2 is initialized
        if (select2.classList.contains('select2-hidden-accessible')) {
            $('#' + select2.id).select2('destroy');
        }
    },
}
$(function(){
    Select2Auto.init();

    // init again on redrawn snippets in datagrid
    $(document).ajaxComplete(function (event, xhr, settings) {
        if (
            xhr.hasOwnProperty('responseText')
            && typeof xhr.responseText === 'string'
            && xhr.responseText.includes('_datagrid')
        ) {
            Select2Auto.init();
        }
    });

    $.nette.ext('snippetListener', {
        success: function (payload) {
            if (payload.snippets) {
                Select2Auto.init();
            }
        }
    });
});
